export class  ChargeType {
    intrChargeTypcode: string
    portfolioId: number;
}